import React, { useState } from "react";
import { Modal, Box, TextField, Button, Tooltip } from "@mui/material";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid cadetblue",
  padding: "20px",
  textAlign: "center",
  borderRadius: "5px",
};

const RejectModal = ({ open, handleClose, onReject }) => {
  const [rejectReason, setRejectReason] = useState("");

  const handleReject = () => {
    onReject(rejectReason);
    setRejectReason("");
    handleClose();
  };

  return (
    <Modal open={open} onClose={handleClose} size="md">
      <Box sx={modalStyle}>
        <TextField
          label="Reason For Rejection"
          value={rejectReason}
          multiline
          rows={5}
          fullWidth
          variant="outlined"
          size="small"
          style={{ marginBottom: "10px" }}
          onChange={(e) => setRejectReason(e.target.value)}
        />
        <Tooltip title="Send Rejection Reason" placement="top-start">
          <Button
            variant="contained"
            color="error"
            size="small"
            sx={{ m: 2 }}
            onClick={handleReject}
            disabled={!rejectReason.trim()}
          >
            Reject
          </Button>
        </Tooltip>
      </Box>
    </Modal>
  );
};

export default RejectModal;
